module.exports = __webpack_public_path__ + "static/media/grifols.ccd99cff.svg";